import React, { Component } from 'react';

import './styles.css';

import WarehouseComponent from '../Warehouses-small/Warehouses';


export default class Modal extends Component {

    constructor(props) {
        super(props)
        this.state = {
            sku: "",
            altVendorNumber: "",
            warehouses: [],
            nipoBaseCost: "",
            nipoCoreCost: "",
            itemsAvailable: "",
            itemsAnnaulCommitment: "",
            unitsPerCase: "",
            casesPerTier: "",
            tiersPerPallet: "",
            companyPOQ: "",
            expirationDate: "",
            remainingAvailable: ""
        }

        this.handleSku = this.handleSku.bind(this);
        this.handleAltVendor = this.handleAltVendor.bind(this);
        this.handleAltVendor = this.handleAltVendor.bind(this);
        this.handleNipoBaseCost = this.handleNipoBaseCost.bind(this);
        this.handleNipoCoreCost = this.handleNipoCoreCost.bind(this);
        this.handleItemsAvailable = this.handleItemsAvailable.bind(this);
        this.handleItemsAnnual = this.handleItemsAnnual.bind(this);
        this.handleUnitsPerCase = this.handleUnitsPerCase.bind(this);
        this.handleCasesPerTer = this.handleCasesPerTer.bind(this);
        this.handleTiersPerPallet = this.handleTiersPerPallet.bind(this);
        this.handleCompanyPOQ = this.handleCompanyPOQ.bind(this);
        this.handleExpirationDate = this.handleExpirationDate.bind(this);
        this.handleRemainingAvail = this.handleRemainingAvail.bind(this);
    }

    closeModal = e => {
        this.props.onClose && this.props.onClose(e);
    };

    onClose = e => {
        if(this.state.sku !== '' || this.state.altVendorNumber !== '' || this.state.nipoBaseCost !== '' || this.state.nipoCoreCost !== '' || this.state.warehouses.length > 0 
        || this.state.itemsAvailable !== '' || this.state.itemsAnnaulCommitment !== '' || this.state.unitsPerCase !== '' || this.state.casesPerTier !== '' 
        || this.state.tiersPerPallet !== '' || this.state.companyPOQ !== '' || this.state.expirationDate !== '' || this.state.remainingAvailable !== '') {
            this.props.onData(true);
        } else {
            this.props.onClose && this.props.onClose(e);
        }
       
    };

    handleSku(event) {
        const value = event.target.value;
        this.setState({sku: value});
    }

    handleAltVendor(event) {
        const value = event.target.value;
        this.setState({altVendorNumber: value});
    }

    handleNipoBaseCost(event) {
        const value = event.target.value;
        this.setState({nipoBaseCost: value});
    }

    handleNipoCoreCost(event) {
        const value = event.target.value;
        this.setState({nipoCoreCost: value});
    }

    handleItemsAvailable(event) {
        const value = event.target.value;
        this.setState({itemsAvailable: value});
    }

    handleItemsAnnual(event) {
        const value = event.target.value;
        this.setState({itemsAnnaulCommitment: value});
    }

    handleUnitsPerCase(event) {
        const value = event.target.value;
        this.setState({unitsPerCase: value});
    }

    handleCasesPerTer(event) {
        const value = event.target.value;
        this.setState({casesPerTier: value});
    }

    handleTiersPerPallet(event) {
        const value = event.target.value;
        this.setState({tiersPerPallet: value});
    }

    handleCompanyPOQ(event) {
        const value = event.target.value;
        this.setState({companyPOQ: value});
    }

    handleExpirationDate(event) {
        const value = event.target.value;
        this.setState({expirationDate: value});
    }

    handleRemainingAvail(event) {
        const value = event.target.value;
        this.setState({remainingAvailable: value});
    }

    sendAltVendor = () => {
        const data = {
            data: [JSON.parse(JSON.stringify(this.state))]
        } 

        const cleanData = Object.keys(data.data[0]).map(item => {
            if(data.data[0][item] === "") data.data[0][item] = undefined
        })

        this.props.openNotification(true);
        this.props.onAddItemData(data);
        this.closeModal();
    }

    getWhses = (whses) => {
        const whsesString = whses.join(' ');
        this.setState({warehouses: whsesString})
    }

    cleanState() {
        this.setState({sku: '', altVendorNumber: '', nipoBaseCost: '', nipoCoreCost: '', warehouses: [], itemsAvailable: '', itemsAnnaulCommitment: '', unitsPerCase: '', casesPerTier: '',
        tiersPerPallet: '', companyPOQ: '', expirationDate: '', remainingAvailable: ''});
    }


    render() {
        if(!this.props.show) {
            if(this.state.sku !== '' || this.state.altVendorNumber !== '' || this.state.nipoBaseCost !== '' || this.state.nipoCoreCost !== '' || this.state.warehouses.length > 0 
            || this.state.itemsAvailable !== '' || this.state.itemsAnnaulCommitment !== '' || this.state.unitsPerCase !== '' || this.state.casesPerTier !== '' 
            || this.state.tiersPerPallet !== '' || this.state.companyPOQ !== '' || this.state.expirationDate !== '' || this.state.remainingAvailable !== '') {
               this.cleanState();
            }
            return null;
        }
        return (
            <div className="modal-background">
                <div className="modal-altvendor-container">
                    <div className="modal-altvendor-form">
                        <h2 className="modal-title">Add Vendor</h2>
                            <div className="modal-row-container">
                                <div className="modal-altvendor-inputs-container">
                                    <label htmlFor="item-number" className="modal-altvendor-label">Item Number</label>
                                    <input type="text" id="item-number" name="item-number" className="input-altvendor-modal" value={this.state.sku} onChange={this.handleSku}/>
                                </div>
                                <div className="modal-altvendor-inputs-container">
                                    <label htmlFor="annual-commit" className="modal-altvendor-label">Annual Commit</label>
                                    <input type="text" id="annual-commit" name="annual-commit" className="input-altvendor-modal" value={this.state.itemsAnnaulCommitment} onChange={this.handleItemsAnnual}/>
                                </div>
                            </div>
                            <div className="modal-row-container">
                                <div className="modal-altvendor-inputs-container">
                                    <label htmlFor="vendor-number" className="modal-altvendor-label">Vendor Number</label>
                                    <input type="text" id="vendor-number" name="vendor-number" className="input-altvendor-modal" value={this.state.altVendorNumber} onChange={this.handleAltVendor}/>
                                </div>
                                <div className="modal-altvendor-inputs-container">
                                    <label htmlFor="remaining-avail" className="modal-altvendor-label">Remaining Avail</label>
                                    <input type="text" id="remaining-avail" name="remaining-avail" className="input-altvendor-modal" value={this.state.remainingAvailable} onChange={this.handleRemainingAvail}/>
                                </div>
                            </div>
                            <div className="modal-row-container">
                                <div className="modal-altvendor-inputs-container">
                                    <label htmlFor="warehouses" className="modal-altvendor-label">Warehouse(s)</label>
                                    <WarehouseComponent whsesData={this.getWhses}/>
                                </div>
                                <div className="modal-altvendor-inputs-container">
                                    <label htmlFor="units-per-case" className="modal-altvendor-label">Units Per Case</label>
                                    <input type="text" id="units-per-case" name="units-per-case" className="input-altvendor-modal" value={this.state.unitsPerCase} onChange={this.handleUnitsPerCase}/>
                                </div>
                            </div>
                            <div className="modal-row-container">
                                <div className="modal-altvendor-inputs-container">
                                    <label htmlFor="nipo-base-cost" className="modal-altvendor-label">NIPO Base Cost</label>
                                    <input type="text" id="nipo-base-cost" name="nipo-base-cost" className="input-altvendor-modal" value={this.state.nipoBaseCost} onChange={this.handleNipoBaseCost}/>
                                </div>
                                <div className="modal-altvendor-inputs-container">
                                    <label htmlFor="cases-per-tier" className="modal-altvendor-label">Cases Per Tier</label>
                                    <input type="text" id="cases-per-tier" name="cases-per-tier" className="input-altvendor-modal" value={this.state.casesPerTier} onChange={this.handleCasesPerTer}/>
                                </div>
                            </div>
                            <div className="modal-row-container">
                                <div className="modal-altvendor-inputs-container">
                                    <label htmlFor="nipo-core-cost" className="modal-altvendor-label">NIPO Core Cost</label>
                                    <input type="text" id="nipo-core cost" name="nipo-core-cost" className="input-altvendor-modal" value={this.state.nipoCoreCost} onChange={this.handleNipoCoreCost}/>
                                </div>
                                <div className="modal-altvendor-inputs-container">
                                    <label htmlFor="tiers-per-pallet" className="modal-altvendor-label">Tiers Per Pallet</label>
                                    <input type="text" id="tiers-per-pallet" name="tiers-per-pallet" className="input-altvendor-modal" value={this.state.tiersPerPallet} onChange={this.handleTiersPerPallet}/>
                                </div>
                            </div>
                            <div className="modal-row-container">
                                <div className="modal-altvendor-inputs-container">
                                    <label htmlFor="avail-inventory" className="modal-altvendor-label">Avail Inventory</label>
                                    <input type="text" id="avail-inventory" name="avail-inventory" className="input-altvendor-modal" value={this.state.itemsAvailable} onChange={this.handleItemsAvailable}/>
                                </div>
                                <div className="modal-altvendor-inputs-container">
                                    <label htmlFor="company-moq" className="modal-altvendor-label">Company POQ</label>
                                    <input type="text" id="company-moq" name="company-moq" className="input-altvendor-modal" value={this.state.companyPOQ} onChange={this.handleCompanyPOQ}/>
                                </div>
                            </div>
                            <div className="modal-row-container">
                                <div className="modal-altvendor-inputs-container">
                                    <label htmlFor="avail-inventory" className="modal-altvendor-label">Expiration Date</label>
                                    <input type="date" id="avail-inventory" name="expiration-date" className="input-altvendor-modal-exp" onChange={this.handleExpirationDate}/>
                                </div>
                            </div>
                    </div>
                    <div className="altvendor-actions-buttons">
                        <button type="button" className="btn btn-warning modal-altvendor-button btn-sm" onClick={e => {this.onClose(e)}}>Return</button>
                        <button type="button" className="btn btn-warning modal-altvendor-button btn-sm" onClick={this.sendAltVendor}>Add</button>
                    </div>     
                </div>
            </div>
            

        );
    }

}